<template>
  <v-container id="page-drive-log">
    <div class="page-title">{{$route.name}}</div>

    <v-row justify="end" class="mr-2">
      <v-menu
        v-model="startMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <div style="width: 250px; margin-right: 15px">
            <v-row>
              <v-text-field
                v-model="searchDateRangeDisplay"
                label="시작일 ~ 종료일"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </v-row>
          </div>
        </template>
        <c-date-range-picker
            v-model="searchDates"
            firstDayOfWeek="1"
            :pickerDate="searchDates[0]"
            locale="ko-kr"
            :min="$func.dateStringAddMonths($func.stringToDate(searchDates[1]), -6)"
            @input="startMenu = false"
        ></c-date-range-picker>
      </v-menu>
      <div style="width: 200px; margin-left: 10px;">
        <v-select
            label="검색 유형"
            :items="searchOptions"
            item-text="label"
            item-value="value"
            v-model="searchType"
        />
      </div>
      <div style="width: 300px">
        <v-text-field
          v-model="keyword"
          label="검색어"
          prepend-icon="search"
          maxlength="32"
          @keypress.enter="searchDriveLogList"
        ></v-text-field>
      </div>
      <v-div style="display: flex; align-items: center; margin-left: 10px">
        <v-btn color="blue" outlined small @click="searchDriveLogList">검색</v-btn>
      </v-div>
    </v-row>
    <c-card outlined class="mb-3">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <span class="">주행 현황</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">대기</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <span class="display-1">{{ this.driveStatus.wait }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">주행</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <span class="display-1">{{ this.driveStatus.drive }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">도움서비스</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <span class="display-1">{{ this.driveStatus.service }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">주행 완료</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <span class="display-1">{{ this.driveStatus.done }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <span class="">결제 현황</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">결제 완료</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <span class="display-1">{{ this.paymentStatus.paid }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">결제 미완료</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <c-btn
              :text="!onlyUnpaid"
              :color="onlyUnpaid ? '#FFE2E4' : ''"
              depressed
              @click="searchIncompletePay(onlyUnpaid = !onlyUnpaid)"
          >
            <div class="red--text display-1" style="display:inline-block;">{{ this.paymentStatus.unpaid }}</div>
          </c-btn>
        </v-col>
      </v-row>
    </c-card>
    <c-table
        :headers="tableHeader"
        :items="tableData"
        :totalElements="totalElements"
        :tableOptions.sync="tableOptions"
        :loading="loading"
    >
      <template #idx="{ item }">
        {{ item.idx }}
      </template>
      <template #startTime="{item}">
        {{ item.startTime ? $func.dateTimeToString(item.startTime) : '-' }}
      </template>
      <template #endTime="{item}">
        {{ item.endTime ? $func.dateTimeToString(item.endTime) : '-'}}
      </template>
      <template #suburban="{item}">
        {{ item.isSuburban ? '시외' : '시내' }}
      </template>
      <template #addr="{item}">
        {{ item.departure }}<br>
        {{ item.destination }}
      </template>
      <template #totalFee="{item}">
        {{ Number(item.totalFee).toLocaleString() }}
        <c-btn v-if="checkDriveStateIsDone(item)" color="grey" icon iconName="create" iconSize="16" inline
                 @click="() => onUpdateDriveLogUpdateFee(item)"/>
      </template>
      <template #totalPaidFee="{item}">
        {{ Number(item.totalPaidFee).toLocaleString() }}
      </template>
      <template #details="{item}">
        <c-btn icon iconName="search" :to="`/driveLog/${item.id}`"></c-btn>
      </template>
    </c-table>

    <drive-log-update-fee-dialog
        :open.sync="updateDriveLogUpdateFeeDialog"
        :driveLogFeeFormData="driveLogFeeFormData"
        :driveLogFeeInfo="driveLogFeeInfo"
        @reqUpdateDriveLogFee="reqUpdateDriveLogFee"
    />
    <v-overlay
      :value="loading"
    >
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
  import DriveLogUpdateFeeDialog from './DriveLogUpdateFeeDialog';

  export default {
    name: 'DriveLog',
    components: {
      DriveLogUpdateFeeDialog
    },
    data() {
      return {
        loading: false,
        searchDates: [this.$func.curDateStringAddDays(-7), this.$func.curDateString()],
        page: 1,
        size: 10,
        sort: '',
        tableOptions: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
        },
        totalElements: 0,
        driveStatus: {
          done: 0,
          drive: 0,
          service: 0,
          wait: 0,
        },
        paymentStatus: {
          paid: 0,
          unpaid: 0,
        },
        keyword: '',
        onlyUnpaid: false,
        startMenu: false,
        endMenu: false,
        keywordMenu: false,
        searchType: 'plateNo',
        searchOptions: [
          {
            label: '차량번호',
            value: 'plateNo'
          },
          {
            label: '기사이름',
            value: 'driverName'
          },
          {
            label: '예약자이름',
            value: 'customerName'
          }
        ],
        tableHeader: [
          {
            text:'번호',
            value: 'idx',
            align: 'center',
            sortable: false,
          },
          {
            text:'출발시간',
            value: 'startTime',
            align: 'center',
            sortable: true,
          },
          {
            text:'도착시간',
            value: 'endTime',
            align: 'center',
            sortable: true
          },
          {
            text:'기사이름',
            value: 'driveName',
            align: 'center',
            sortable: true,
          },
          {
            text:'차량번호',
            value: 'plateNo',
            align: 'center',
            sortable: true,
          },
          {
            text:'예약자',
            value: 'customerName',
            align: 'center',
            sortable: true,
          },
          {
            text: "시내 / 시외",
            value: "suburban",
            align: "center",
            sortable: false,
          },
          {
            text:'출발지/도착지',
            value: 'addr',
            align: 'center',
            sortable: false,
          },
          {
            text:'진행 상황',
            value: 'driveStatusName',
            align: 'center',
            sortable: false,
          },
          {
            text:'요금(원)',
            value: 'totalFee',
            align: 'center',
            sortable: false,
          },
          {
            text:'실 결제요금(원)',
            value: 'totalPaidFee',
            align: 'center',
            sortable: false,
          },
          {
            text:'결제 상황',
            value: 'payStatusName',
            align: 'center',
            sortable: false,
          },
          {
            text:'상세보기',
            value: 'details',
            align: 'center',
            sortable: false
          },
        ],
        driveLog: [],
        tableData: [],
        updateDriveLogUpdateFeeDialog: false,
        driveLogFeeFormData: {},
        driveLogFeeInfo: {},
        details: null
      }
    },
    computed: {
      searchDateRangeDisplay() {
        return this.searchDates.join(' ~ ')
      }
    },
    watch: {
      searchDates: function () {
        this.searchDriveLogList();
      },
      tableOptions: function(options) {
        this.page = options.page
        this.size = options.itemsPerPage

        if (options.sortBy.length) {
          let sortBy = options.sortBy[0]
          if (options.sortBy[0] === 'driveName') {
            sortBy = 'driverName'
          }
          this.sort = `${sortBy},${options.sortDesc[0] ? 'desc' : 'asc'}`
        } else {
          this.sort = `startTime,desc` // default
        }

        if (this.onlyUnpaid) {
          this.searchIncompletePay();
        } else {
          this.reqDriveLogList();
        }
      }
    },
    activated() {
      this.reqDriveLogList();
    },
    methods: {
      async searchDriveLogList() {
        this.page = 1
        this.tableOptions.page = 1
        await this.reqDriveLogList()
      },
      async reqDriveLogList() {
        try {
          this.loading = true;
          const params = {
            startDate: this.searchDates[0],
            endDate: this.searchDates[1],
            searchType: this.searchType,
            searchKeyword: this.keyword,
            page: this.page,
            size: this.size,
            sort: this.sort
          }
          let data = null;
          if (params.searchKeyword) {
            this.onlyUnpaid = false;
            const res = await this.$api.getDriveLogListBySearchKeyword(params)
            data = res.data
          } else {
            const res = await this.$api.getDriveLogList(params)
            data = res.data
          }
          this.tableData = data.driveLogInfoList.content.map((item, index) => {
            item.idx = (index + (( this.page - 1 ) * this.size) ) + 1
            item.payStatusName = item.paymentStatus.configName
            item.driveStatusName = item.driveStatus.configName
            return item
          })
          this.totalElements = data.driveLogInfoList.totalElements

          this.driveStatus = data.driveStatus;
          this.paymentStatus = data.paymentStatus;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqDriveLogList', msg: err.message ? err.message : '문제가 발생하였습니다. 잠시후 다시 시도해주세요.'});
        } finally {
          this.loading = false;
        }
      },
      async onUpdateDriveLogUpdateFee(item) {
        const res = await this.$api.getDriveLogById(item.id);
        const details = res.data;

        this.driveLogFeeFormData = {
          driveLogId: details.id,
          waitFee: details.waitFee,
          driveFee: details.driveFee,
          serviceFee: details.serviceFee,
          extraFee: details.extraFee,
          discountFee: details.discountFee,
        };
        this.driveLogFeeInfo = {
          customerName: item.customerName,
          driverName: item.driverName,
          plateNo: item.plateNo,
          totalPaidFee: item.totalPaidFee,
          payStatusName: item.payStatusName,
        }
        this.updateDriveLogUpdateFeeDialog = true;
      },
      async reqUpdateDriveLogFee(data) {
        try {
          await this.$api.updateDriveLogFee(data);
          this.updateDriveLogUpdateFeeDialog = false;
          await this.reqDriveLogList();
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqUpdateDriveLogFee'});
        }
      },
      checkDriveStateIsDone(item) {
        return item.driveStatus && item.driveStatus.configValue === 'ds_done';
      },
      async searchIncompletePay() {
        if (this.onlyUnpaid) {
          this.searchType = '';
          this.keyword = '';
          const params = {
            startDate: this.searchDates[0],
            endDate: this.searchDates[1],
            searchType: 'payStatus',
            searchKeyword: 'onlyUnpaid',
            page: this.page,
            size: this.size,
            sort: this.sort
          }
          const { data } = await this.$api.getDriveLogListBySearchKeyword(params)

          this.tableData = data.driveLogInfoList.content.map((item, index) => {
            item.idx = (index + (( this.page - 1 ) * this.size) ) + 1
            item.payStatusName = item.paymentStatus.configName
            item.driveStatusName = item.driveStatus.configName
            return item
          })
          this.totalElements = data.driveLogInfoList.totalElements
        } else {
          await this.reqDriveLogList()
        }
      }
    }
  }
</script>

<style scoped>

</style>
